export default {
	InvitationCode: "Kod Zaproszenia",
	CreditScore: "Wynik Kredytowy",
	MyFinancial: {
		title: "Moje Finanse",
		menu: ["Depozyt", "Wypłata", "Transakcja"]
	},
	MyDetail: {
		title: "Moje Szczegóły",
		menu: ["Informacje Osobiste", "Metody Płatności"]
	},
	Other: {
		title: "Inne",
		menu: ["Kontakt", "Powiadomienia", "Zmień Język"]
	},
	Amount: ["Saldo Portfela", "Zamrożone Saldo", "Dzisiejsze Zarobki"],
	Logout: {
		title: "Wyloguj się",
		content: "Czy na pewno chcesz się wylogować?"
	}
};
